export const messages = {
  BACK: "back",
  TAX: "tax",
  FEE: "fee",
  TOTAL: "total",
  APPLY: "apply",
  RESERVE: "reserve",
  DISCOUNT: "discount",
  CONTINUE: "continue",
  CHECKOUT: "checkout",
  SUB_TOTAL: "subtotal",
  UNRESERVE: "unreserve",
  MY_EVENTS: "my events",
  ADD_TO_CART: "add to cart",
  SERVICE_FEE: "service fee",
  UPDATE_CART: "update cart",
  SELECT_EVENTS: "select events",
  VIEW_SAMPLE: "view sample",
  NO_RECAP_FOUND: "no recap found",
  SELECT_DURATION: "select duration",
  CONFIRM_BOOKING: "confirm booking",
  REMAINING_BALANCE: "remaining balance",
  APPLIED_GIFT_CARD: "applied gift card",
  GIFT_CARD_BALANCE: "gift card balance",
  BACK_TO_MY_EVENTS: "back to my events",
  REQUIRED_FIELD: "this field is required",
  SUBMIT_SUCCESSFULLY: "submit successfully",
  PROCEED_TO_CHECKOUT: "proceed to checkout",
  UPLOADED_SUCCESSFULLY: "uploaded successfully",
  PAY_WITH_GIFT_CARD: "pay with gift card",
  PLEASE_SELECT_EVENT_TYPE: "please select reel type",
  UNSUPPORTED_IMAGE_FORMAT: "unsupported image format. please upload a file in .png, .jpg or .jpeg format.",
  PLEASE_SELECT_ORIENTATION: "please select orientation",
  PLEASE_SELECT_MUSIC_STYLE: "please select music style",
  ERROR_SAVING_LOCAL_STORAGE: "error saving to localStorage",
  SOME_FIELDS_IS_MISSING: "some fields is missing or invalid",
  EVENT_SHOT_LIST_IS_EMPTY: "event shot list is empty",
  ACCEPT_PRIVACY_POLICY: "you must accept the privacy policy",
  PLEASE_SELECT_VIDEO_DURATION: "please select video duration",
  IMAGE_SIZE_EXCEEDED: "the image size exceeds the 5 mb limit",
  FAILED_TO_PARSE_LOCAL_STORAGE: "failed to parse localStorage item",
  LOCAL_STORAGE_WARNING: "localStorage quota exceeded. could not save",
  PLEASE_ENTER_VALID_PHONE_NUMBER: "please enter a valid phone number",
  ACCEPT_TERMS_AND_CONDITION: "you must accept the terms & conditions",
  PARSE_DATA_EVENT_IS_NOT_AN_ARRAY: "parsedData event is not an array",
  EDIT_BRIEF_MESSAGE: "please complete the edit brief before proceeding",
  PLEASE_SELECT_EVENTS_FOR_COMBINED_REEL:
    "please select at least two events for the combined reel",
  EACH_RECAP_MUST_HAVE_ORIENTATION_TYPE:
    "each recap must have orientation type.",
  TIP_YOUR_SHUTTERB_FOR_A_JOB_WELL_DONE:
    "tip your shutterb for a job well done",
  PLEASE_SELECT_ATLEAST_1_SHUTTERB_TO_TIP:
    "please select at least 1 shutterb to tip",
  EXTEND_YOUR_SHUTTERB: "extend your shutterb",
  PLEASE_SELECT_ATLEAST_1_SHUTTERB_TO_EXTEND:
    "please select atleast 1 shutterb to extend with duration",

  // TOAST MESSAGES
  CART_UPDATED_SUCCESSFULLY: "cart updated successfully",
  INVALID_TIP_AMOUNT: "tip amount must be greater than 3",
  FEEDBACK_TIMELIMIT_EXPIRED: "feedback time limit expired",
  FEEDBACK_IS_ALREADY_SUBMITTED: "feedback is already submitted",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_EVENT:
    "are you sure you want to delete Event#",
  EVENT_DELETION_WILL_TRIGGER_REFUND_IF_PROCEEDED:
    "you are attempting to delete an existing event. if you proceed, the event amount will be refunded for Event#",
  PLEASE_SELECT_ATLEAST_1_SHUTTERB_WITH_TIP_PRICE_3_DOLLAR_MINIMUM:
    "please select atleast 1 shutterb with tip price 3 dollar minimum",
  ONLY_10_EVENTS_CAN_BE_CREATED_AT_A_TIME:
    "only 10 events can be created at a time",
  PLEASE_ENSURE_ALL_EVENT_DATES_ARE_ON_OR_AFTER_TOMORROW:
    "please ensure all event dates are on or after tomorrow",
  Please_Specify_What_Type_Of_Recap_You_Would_Like_For_Each_Edit:
    "please specify what type of recap you would like for each edit?",
  Click_On_The_Tiles_Above_To_See_A_Sample_Of_Each_Recap:
    "click on the tiles above to see a sample of each recap",
  PLEASE_SELECT_SHUTTERB:
    "please select at least one shutterb for event",
  YOU_HAVE_REACHED_THE_MAXIMUM_NUMBER_OF_EVENTS_FOR_YOUR_ORDER:
    "you have reached the maximum number of events allowed for your order",
  // ERROR MESSAGES
  Time_Is_Required: "time is required",
  File_Name_Is_Required: "file name is required",
  Action_Type_Is_Required: "action type is required",
  RECAP_FILE_IS_REQUIRED: "recap file is required",
  FILE_ALREADY_SELECTED: "file already selected",
  FEEDBACK_Is_Required: "feedback is required",

  // API RESPONSE MESSAGES
  EVENT_SUCCESSFULLY_SAVED: "event_successfully_saved",
  EVENT_SUCCESSFULLY_SAVED_AS_DRAFT: "event_successfully_saved_as_draft",
  NO_SHUTTERB_AVAILABLE_IN_THIS_LOCATION:
    "no_shutterB_available_in_this_location",
  REGENERATE_EDIT_BRIEF_CONFIRMATION_MESSAGE: 
  "detected changes in recaps.\n\ndo you want to regenerate edit briefs based on updated selections?",
  LET_GET_YOU_EDIT_RIGHT: "let's get your edit(s) just right.",
  TELL_US_WHAT_TYPE_OF_RECAP_YOU_WOULD_LIKE: 
  "before we propose your custom edit brief, tell us what type of recap(z) you’d like. once you choose, we’ll shape the brief around your selections and the number of edits you ordered.",
  THESE_ARE_THE_TYPES_OF_EDITS_WE_OFFER: "these are the types of edits we offer:"
};
